import React, {useEffect, useRef, useContext, useState} from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// data & context
import data from "../../../data"
import {ShopContext} from "../../../context"

// components
import {Link, Money} from "../../controls"

// styling & icons
import "./ShoppingList.scss"
import {faAngleRight} from "@fortawesome/free-solid-svg-icons";

// scroll
let scrollInfo = {
  elAnchor:null,
  elContent:null
}

const scrollHandler = _.debounce(() => {
  /*
  if(scrollInfo.elAnchor && scrollInfo.elContent) {
    let boundingRectAnchor = scrollInfo.elAnchor.getBoundingClientRect()
    if(boundingRectAnchor.top < 68 ) { // TODO the hard-coded value comes from the height of the header
      scrollInfo.elContent.style.position = "fixed"
      scrollInfo.elContent.style.top = "68px"
    }
    else {
      scrollInfo.elContent.style.position = "relative"
      scrollInfo.elContent.style.top = "0"
    }
  }
  */
}, 100) 


// the component
function ShoppingList(props) {
  // state
  const [cartSignature, setCartSignature] = useState(null) // used to force update if cart changes

  // refs
  const refAnchor = useRef()
  const refContent = useRef()

  // context
  const shop = useContext(ShopContext)

  // items in cart changed
  useEffect(() => {
    setCartSignature(shop.cartSignature)
  }, [shop.cartSignature])

  // handle scroll event
  useEffect(() => {
    // subscribe to scroll event
    window.addEventListener('scroll', scrollHandler, true)

    // unsubscribe scroll event
    return () => { 
      window.removeEventListener('scroll', scrollHandler)
    }
  }, [])

  useEffect(() => {
    if(refAnchor.current && refContent.current) {
      scrollInfo.elAnchor = refAnchor.current
      scrollInfo.elContent = refContent.current
    }
    else {
      scrollInfo.elAnchor = null
      scrollInfo.elContent = null
    }
  }, [refAnchor.current, refContent.current])
  

  // the table rows we are going to render
  const rows = [];

  // included activity package (if any)
  const activityPackageInfo = data.Cart.getAdventure().ActivityPackage;

  // have activities (activity or activity package)?
  const hasActivities = data.Cart.getActivities().length > 0 || activityPackageInfo;

  // activity package included?
  if(activityPackageInfo) {
    rows.push(
      <tr key="activitypackage">
        <td>{activityPackageInfo.activityPackage.title}</td>
        <td><Money amount={activityPackageInfo.price} showCurrency={false} /></td>
      </tr>
    )
    // rows.push(
    //   <tr key="activitypackage_discount">
    //     <td>Kombinationsrabatt:</td>
    //     <td>- <Money amount={activityPackageInfo.discount} showCurrency={false} /></td>
    //   </tr>
    // )
  }

  // the items
  data.Cart.getActivities()
  .filter(a => {
    // if we have an activity package, we do not display activities contained in there
    if(activityPackageInfo) {
      if(activityPackageInfo.activityIds.includes(a.Activity_ID)) {
        return false;
      }
    }
    return true;
  })
  .forEach(a => {
    rows.push(
      <tr key={a.Activity_ID}>
        <td>
          <Link to={`/activity/${a.ActivityInfo.slug}`}>
            {a.ActivityInfo.title}
          </Link>
        </td>
        <td><Money amount={a.CalculatedPrice} showCurrency={false} /></td>
      </tr>
    )
  });

  // shipping / packaging
  let shippingInfo = data.Cart.getShippingInfo()
  if(shippingInfo) {
    rows.push(
      <tr key="shipping_info">
        <td>{`${shippingInfo.packaging} + Versand`}</td>
        <td><Money amount={shippingInfo.price} showCurrency={false} /></td>
      </tr>
    )
  }

  // voucher?
  let voucher = data.Cart.getVoucher()
  if(voucher) {
    let totalDiscount = data.Cart.getValue("totalDiscount") || 0
    rows.push(
      <tr key="voucher">
        <td>{`Promocode ${voucher.code}`}</td>
        <td>- <Money amount={totalDiscount} showCurrency={false} /></td>
      </tr>
    )
  }

  

  // total
  if(rows.length > 0) {
    rows.push(
      <tr key="total" className="total">
        <td>Total</td>
        <td className="total">
          <Money amount={data.Cart.getTotalCost()} displayVatInfo={true} total />
        </td>
      </tr>
    )
    if(props.showCheckoutLink) {
      rows.push(
        <tr key="checkout" className="checkout">
          <td colSpan="2">
            <Link to="/checkout">
              <div className="button">
                zur Kasse <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </Link>
          </td>
        </tr>
      )
    }
  }

  // the list
  let list
  if(hasActivities) {
    list = (
      <table><tbody>
        {rows}
      </tbody></table>
    )
  }
  else {
    list = (
      <div id="s-shoppinglist-empty">Dein Warenkorb ist noch leer</div>
    )
  }

  // shipping eta
  let shippingEta = null
  const showEta = hasActivities
  if(showEta) {
    let info = data.Cart.getShippingInfo()
    shippingEta = (
      <div id="s-shoppinglist-shipping-eta">
        Voraussichtliches Lieferdatum:<br/>{info.when}
      </div>
    )
  }

  // render
  return (
    <div id="s-shoppinglist">
      <div id="s-shoppinglist-anchor" ref={refAnchor}></div>
      <div id="s-shoppinglist-content" ref={refContent}>
        {list}
        {shippingEta}
      </div>
    </div>
  )
}

ShoppingList.propTypes = {
  showCheckoutLink:PropTypes.bool.isRequired
}

ShoppingList.defaultProps = {
  showCheckoutLink:true
}

export default ShoppingList